import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


export const constantRoutes = [
	{
		path: '/login',
		name: 'login',
		component: () => import("@/views/login")
	},
	{
		path: '/register',
		name: 'register',
		component: () => import("@/views/register")
	},
	{
		path: '/user_agreement',
		name: 'user_agreement',
		component: () => import("@/views/user_agreement")
	},
	{
		path: '/forgot_password',
		name: 'forgot_password',
		component: () => import("@/views/forgot_password")
	},
	{
		path: '/404',
		component: () => import('@/views/404')
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: () => import("@/views/dashboard")
	}, // 首页
	{
		path: '/',
		redirect: '/dashboard',
	},
	{
		path: '/tender_notice',
		name: 'tender_notice',
		component: () => import("@/views/information_list")
	}, // 招标公告
	{
		path: '/win_bid',
		name: 'win_bid',
		component: () => import("@/views/information_list")
	}, // 中标公告
	{
		path: '/construction',
		name: 'construction',
		component: () => import("@/views/information_more")
	}, // 拟在建
	{
		path: '/vip_project',
		name: 'vip_project',
		component: () => import("@/views/information_more")
	}, // VIP项目
	{
		path: '/exclusive_items',
		name: 'exclusive_items',
		component: () => import("@/views/information_more")
	}, // 独家项目
	{
		path: '/information_detail',
		name: 'information_detail',
		component: () => import("@/views/information_detail")
	}, // 公告详情
	{
		path: '/supplier_library',
		name: 'supplier_library',
		component: () => import("@/views/supplier_library")
	}, // 供应商库
	{
		path: '/added_services',
		name: 'added_services',
		component: () => import("@/views/added_services")
	}, // 增值服务
	{
		path: '/join_membership',
		name: 'join_membership',
		component: () => import("@/views/join_membership")
	}, // 开通会员
	{
		path: '/advanced_search',
		name: 'advanced_search',
		component: () => import("@/views/advanced_search")
	}, // 开通会员
	{
		path: '/personal_center',
		name: 'personal_center',
		component: () => import("@/views/personal_center"),
	}, // 个人中心
	{
		path: '/personal_center/advanced_search',
		name: 'personal_advanced_search',
		component: () => import("@/views/personal_center/AdvancedSearch"),
	}, // 个人中心-高级搜索
	{
		path: '/personal_center/release_news',
		name: 'release_news',
		component: () => import("@/views/personal_center/ReleaseNews")
	}, // 发布信息
	{
		path: '/personal_center/manage_news',
		name: 'manage_news',
		component: () => import("@/views/personal_center/ManageNews")
	}, // 管理信息
	{
		path: '/personal_center/focus_custom',
		name: 'focus_custom',
		component: () => import("@/views/personal_center/FocusCustom")
	}, // 焦点定制
	{
		path: '/personal_center/modify_data',
		name: 'modify_data',
		component: () => import("@/views/personal_center/ModifyData")
	}, // 修改资料
	{
		path: '/personal_center/change_password',
		name: 'change_password',
		component: () => import("@/views/personal_center/ChangePassword")
	}, // 修改密码
	{
		path: '/navigation',
		name: 'navigation',
		component: () => import("@/views/navigation")
	}, // 底部导航
	// 404 page must be placed at the end !!!
	{ path: '*', redirect: '/404' }
]



const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js